export const PersonStandingCascade = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      opacity="0.2"
      d="M25.3333 26.6668L21.3333 18.6668V13.3335L29.3333 10.6668M22.6667 6.66683C22.6667 7.40321 22.0697 8.00016 21.3333 8.00016C20.597 8.00016 20 7.40321 20 6.66683C20 5.93045 20.597 5.3335 21.3333 5.3335C22.0697 5.3335 22.6667 5.93045 22.6667 6.66683Z"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M20 26.6668L16 18.6668V13.3335L24 10.6668M17.3333 6.66683C17.3333 7.40321 16.7363 8.00016 16 8.00016C15.2636 8.00016 14.6666 7.40321 14.6666 6.66683C14.6666 5.93045 15.2636 5.3335 16 5.3335C16.7363 5.3335 17.3333 5.93045 17.3333 6.66683Z"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66663 26.6668L10.6666 18.6668M10.6666 18.6668L14.6666 26.6668M10.6666 18.6668V13.3335M2.66663 10.6668L10.6666 13.3335M10.6666 13.3335L18.6666 10.6668M12 6.66683C12 7.40321 11.403 8.00016 10.6666 8.00016C9.93025 8.00016 9.33329 7.40321 9.33329 6.66683C9.33329 5.93045 9.93025 5.3335 10.6666 5.3335C11.403 5.3335 12 5.93045 12 6.66683Z"
      stroke="#494949"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
